import React from 'react';
import {
  Home,
  Clipboard,
  PhoneIncoming,
  Key,
  Trello,
  Tv,
  Calendar,
  Book,
  Codesandbox,
  Server,
  Info,
  Camera,
  Users,
} from 'react-feather';

import CustomIcon from 'components/base/CustomIcon';
import { OtherTypes } from 'components/base/CustomIcon/types';
import { SidebarOption } from 'components/base/Sidebar';
import config from 'config';

import { SimpleUserRequestPermissionNames } from 'config/apiFunus/generated/data-contracts';
import { i18n } from 'i18n';
import { Permission } from 'models/UserRole';

export const home: SidebarOption = {
  content: i18n.t('menu.home'),
  exact: true,
  icon: <Home />,
  key: 'home',
  url: config.url.landing,
};

export const roles: SidebarOption = {
  content: i18n.t('menu.roles'),
  exact: true,
  icon: <Key />,
  key: 'roles',
  permission: [SimpleUserRequestPermissionNames.USER_READ],
  url: config.url.roles,
};

export const ips: SidebarOption = {
  content: i18n.t('menu.ips'),
  exact: true,
  icon: <Tv />,
  key: 'ips',
  permission: [SimpleUserRequestPermissionNames.USER_READ],
  url: config.url.ips,
};

export const enquiries: SidebarOption = {
  content: i18n.t('menu.enquiries'),
  icon: <PhoneIncoming />,
  key: 'enquiries',
  permission: [SimpleUserRequestPermissionNames.ENQUIRY_READ],
  url: config.url.enquiries,
};

export const enquiriesDashboard: SidebarOption = {
  content: i18n.t('menu.enquiries'),
  icon: <Server />,
  key: 'enquiriesDashboard',
  permission: [SimpleUserRequestPermissionNames.ENQUIRY_READ],
  url: config.url.enquiriesDashboard,
};

export const records: SidebarOption = {
  content: i18n.t('menu.records'),
  icon: <Clipboard />,
  key: 'records',
  permission: [SimpleUserRequestPermissionNames.RECORD_READ],
  url: config.url.records,
};

export const workshop: SidebarOption = {
  content: i18n.t('menu.workshop'),
  exact: true,
  icon: <Trello />,
  key: 'workshop',
  permission: [
    SimpleUserRequestPermissionNames.WORK_ORDER_CEMETERY_READ,
    SimpleUserRequestPermissionNames.WORK_ORDER_WORKSHOP_READ,
  ],
  url: config.url.workshop,
};

export const calendar: SidebarOption = {
  content: i18n.t('menu.calendar'),
  exact: true,
  icon: <Calendar />,
  key: 'calendar',
  permission: [
    SimpleUserRequestPermissionNames.RECORD_ADD,
    SimpleUserRequestPermissionNames.RECORD_ASSIGN,
  ],
  url: config.url.calendarNoInfo,
};

export const agenda: SidebarOption = {
  content: i18n.t('menu.agenda'),
  exact: true,
  icon: <Book />,
  key: 'agenda',
  permission: [
    SimpleUserRequestPermissionNames.RECORD_ADD,
    SimpleUserRequestPermissionNames.RECORD_ASSIGN,
    SimpleUserRequestPermissionNames.WORK_ORDER_CEMETERY_ADD,
    SimpleUserRequestPermissionNames.WORK_ORDER_WORKSHOP_ADD,
  ],
  url: config.url.agendaNoInfo,
};

export const QRRead: SidebarOption = {
  content: i18n.t('menu.viewqr'),
  exact: true,
  icon: <Codesandbox />,
  key: 'qrread',
  permission: [SimpleUserRequestPermissionNames.RECORD_QR_READ],
  url: config.url.viewqr,
};

export const adviceInfo: SidebarOption = {
  content: i18n.t('menu.information'),
  exact: true,
  icon: <Info />,
  key: 'information',
  permission: [SimpleUserRequestPermissionNames.ADVICE_INFO],
  url: config.url.information,
};

export const takeDeliveryPhoto: SidebarOption = {
  content: i18n.t('article.takeDeliveredPhoto'),
  exact: true,
  icon: <Camera data-testid="icon-camera" />,
  key: 'deliveryPhoto',
  permission: [],
  url: config.url.articlePhoto,
};

export const flowerTraking: SidebarOption = {
  content: i18n.t('menu.flowers'),
  exact: true,
  icon: <CustomIcon icon={OtherTypes.FLOWERS} />,
  key: 'flowers',
  permission: [SimpleUserRequestPermissionNames.ARTICLE_READ],
  url: config.url.flowersTraking,
};

export const scanArticleQR: SidebarOption = {
  content: i18n.t('menu.scan'),
  exact: true,
  icon: <Camera data-testid="icon-scan-qr" />,
  key: 'deliveryPhoto',
  permission: [SimpleUserRequestPermissionNames.ARTICLE_QR_READ],
  url: config.url.articleInfo,
};

export const budgetsTracking: SidebarOption = {
  content: i18n.t('budget.title'),
  exact: true,
  icon: <Users />,
  key: 'budgetsTracking',
  permission: [SimpleUserRequestPermissionNames.BUDGET_WRITE],
  url: config.url.budgetsTracking,
};

export const budgetsConfig: SidebarOption = {
  content: i18n.t('budget.config.title'),
  exact: true,
  icon: <CustomIcon icon={OtherTypes.BUDGET_CONFIG} />,
  key: 'budgetsConfig',
  permission: [SimpleUserRequestPermissionNames.BUDGET_RULES_WRITE],
  url: config.url.budgetsArticles,
};

// TODO: Waiting for the client to add
// const sales = {
//   content: i18n.t('menu.sales'),
//   key: 'sales',
//   icon: <DollarSign />,
//   url: config.url.sales,
//   permission: SimpleUserRequestPermissionNames.DIRECT_SALE_READ,
// };

export const getMenuByPermissions = (
  permissions: Permission[],
): SidebarOption[] => {
  const options: SidebarOption[] = [
    roles,
    ips,
    records,
    enquiries,
    enquiriesDashboard,
    workshop,
    calendar,
    agenda,
    QRRead,
    adviceInfo,
    flowerTraking,
    scanArticleQR,
    budgetsTracking,
    budgetsConfig,
  ];

  let menu: SidebarOption[] = [home];

  const menuFiltered: SidebarOption[] = [];

  permissions.forEach((permission) => {
    menu = [
      ...menu,
      ...options.filter(
        (optionSidebar: SidebarOption) => optionSidebar
          .permission?.includes(permission.name),
      ),
    ];

    menu.forEach((optionSidebar: SidebarOption) => {
      if (
        !menuFiltered.find((o: SidebarOption) => optionSidebar.key === o.key)
      ) {
        menuFiltered.push(optionSidebar);
      }
    });
  });
  return menuFiltered;
};

export default getMenuByPermissions;
